import { Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip, Tabs, Tab } from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';
import { AdminToolBar } from '../admin/components';
import { SupportForm } from '.';
import { supportStore } from '.';
import { SupportTicketList } from '.';

const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
    },
    tabRoot: {
    },
    tabsRoot: {
    },
    flexContainer: {
        height: '100%'
    }
});

@observer
class Support extends React.Component<any> {

    constructor(props: any) {
        super(props);
        supportStore.getMedportalTickets(authStore.currentUser.auth_id);
    }

    public handleChangeTab = (event: any, value: number) => {
        supportStore.currentTab = value;
    }

    public getPageContent = (current_tab: number) => {
        switch (current_tab) {
            case (0):
                {
                    return (<SupportTicketList closed={false} ticketList={supportStore.tickets}/>)
                }
            // case (1):
            //     {
            //         return (<SupportForm />)
            //     }
            case (1):
                {
                    return (<SupportTicketList closed={true} ticketList={supportStore.closedTickets}/>)
                }
            default:
                {
                    return (<div>no tab found</div>)
                }
        }
    }

    public render() {
        const { classes } = this.props;

        const getTabs = () => {
            return (
                <Tabs
                    value={supportStore.currentTab}
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={this.handleChangeTab}
                    indicatorColor="secondary"
                    textColor="secondary"
                    classes={{
                        root: classes.tabsRoot,
                        flexContainer: classes.flexContainer
                    }}
                    style={{ height: '100%' }}
                >
                    <Tab
                        classes={{
                            root: classes.tabRoot
                        }}
                        label="My Tickets"
                    />
                    {/* <Tab
                        classes={{
                            root: classes.tabRoot,

                        }}
                        label="Create Ticket"
                    /> */}
                    <Tab
                        classes={{
                            root: classes.tabRoot,

                        }}
                        label="Closed Tickets"
                    />
                </Tabs>
            )
        }

        if (!supportStore.tickets_loaded) {
            return <div>loading</div>
        }

        return (
            <div className={classes.root}>
                <AdminToolBar pageTitle={'Support'} tabs={getTabs()} />
                {this.getPageContent(supportStore.currentTab)}
            </div>
        )

    }

}

export default withStyles(styles, { withTheme: true })(
    withRouter(Support)
);


// WEBPACK FOOTER //
// ./src/modules/support/Support.tsx